// THIS FILE IS ONLY FOR IDE ENTRY CHECKING NOT FOR REAL USAGE

import MarqueeTips from './src/components/MarqueeTips.vue'

export default MarqueeTips



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-marquee-tips@1.0.8@vue-marquee-tips/index.js
// module id = 87iw
// module chunks = 39